import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { AssigneesComponent } from './assignees.component';

@NgModule({
  entryComponents: [
    AssigneesComponent
  ],
  declarations: [
    AssigneesComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,

    MatAutocompleteModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressBarModule
  ],
  exports: [
    AssigneesComponent
  ]
})
export class AssigneesComponentModule {}
